/* eslint-disable jsx-a11y/alt-text */
import React from 'react'
import Base from '../../containers/BaseContainer'
import Dropzone from 'react-dropzone'
import classNames from 'classnames'
import { I18n } from 'react-redux-i18n'
import Alert from '../AlertPopup/Alert'
import Constants from '../../services/constants/Constants'
import styles from './BaseLibrary.module.scss'
import pdfImage from '../../static/img/icn_pdf.svg'
import Toggle from '../Toggle/Toggle'
import Select from 'react-select'
import globalStyles from '../../styles/styles.module.scss'
import filesize from 'filesize.js'
import { Creatable } from 'react-select'

class BaseLibrary extends Base {

  constructor() {
    super()
    this._bind(
      '_handleListGridChange',
      '_renderMediaCheckPreview',
      '_renderMediaPreview',
      '_renderMedia',
      '_renderUploader',
      '_renderUploaderFullSized',
      '_renderViewChanger',
      '_renderMediaType',
      '_renderMediaImagePDF',
      '_handleDeleteMedia',
      '_confirmDeleteMedia',
      '_cancelDeleteMedia',
      '_renderDeleteAlert',
      '_renderProgressSizeBar',
      '_filterAndSortMedia',
      '_renderFilterToolbar',
      '_onToggleUnusedChange',
      '_onToggleUsedChange',
      '_handleSelectChange',
      '_handleReplaceMedia',
      '_confirmReplaceMedia',
      '_cancelReplaceMedia'
    )
  }

  _handleDeleteMedia(event) {
    let mediaId = event.currentTarget.getAttribute('data-id')
    this.setState({ openedAlert: true, mediaToDelete: mediaId })
  }
  _confirmDeleteMedia() {
    this.props.onRemoveFile(this.state.mediaToDelete)
    this.setState({ openedAlert: false, mediaToDelete: null })
  }
  _cancelDeleteMedia(e) {
    this.setState({ openedAlert: false, mediaToDelete: null })
  }

  _handleReplaceMedia(event) {
    let mediaId = event.currentTarget.getAttribute('data-id')
    let newMedia = event.currentTarget.files[0]
    this.setState({ openedReplaceAlert: true, mediaToReplace: mediaId, newMedia })
  }
  _confirmReplaceMedia() {
    this.props.onReplaceFile(this.state.mediaToReplace, this.state.newMedia)
    this.setState({
      openedReplaceAlert: false, mediaToReplace: null, newMedia: null,
      lastMediaReplace: this.state.mediaToReplace,
    })
  }
  _cancelReplaceMedia() {
    this.setState({ openedReplaceAlert: false, mediaToReplace: null, newMedia: null })
  }

  _handleListGridChange(event) {
    this.setState({ gridView: event.currentTarget.checked })
  }
  componentDidMount() {
    if (this.props.app) {
      let tags = this._getTagQuery()
      this.props.fetchMedias(this.props.app.id, this.state.libMediaTypes, this.props.mediasSize, tags)
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selectedMediaTags.length !== this.props.selectedMediaTags.length && this.props.app) {
      let tags = this._getTagQuery()
      this.props.fetchMedias(this.props.app.id, this.state.libMediaTypes, this.props.mediasSize, tags)
    }
  }
  _getTagQuery = () => {
    if (!this.props.selectedMediaTags || !this.props.selectedMediaTags.length) return null
    return this.props.selectedMediaTags.map(st => st.value).join(',')
  }
  _renderDeleteAlert() {
    return (
      <Alert
        opened={this.state.openedAlert}
        messageTitle={'deleteMediaTitle'}
        message={'deleteMediaMessage'}
        confirmButtonTitle={'comfirm'}
        cancelButtonTitle={'cancel'}
        confirmAction={this._confirmDeleteMedia}
        cancelAction={this._cancelDeleteMedia} />
    )
  }

  _renderSizeAlert() {
    return (
      <Alert
        opened={this.props.openedSizeAlert}
        messageTitle={'sizeAlertTitle'}
        message={'sizeAlertMessage'}
        confirmButtonTitle={''}
        cancelButtonTitle={'cancel'}
        confirmAction={null}
        cancelAction={() => this.props.handleCancelFileDrop()}
      />
    )
  }

  _renderReplaceAlert() {
    return (
      <Alert
        opened={this.state.openedReplaceAlert}
        messageTitle={'sizeReplaceTitle'}
        message={'sizeReplaceMessage'}
        confirmButtonTitle={'comfirm'}
        cancelButtonTitle={'cancel'}
        confirmAction={this._confirmReplaceMedia}
        cancelAction={this._cancelReplaceMedia}
      />
    )
  }

  _renderViewChanger(state) {
    return (<div className={styles.viewChanger}>
      <label>
        <input type='checkbox' onChange={this._handleListGridChange} checked={state} />
        <div className={styles.list}></div>
        <div className={styles.grid}></div>
      </label>
    </div>)
  }

  _renderUploader() {
    return (<div className={styles.uploader}>
      <Dropzone
        onDrop={this.props.manageFileDrop}
        activeClassName={styles.dropHover}
        rejectClassName={styles.dropError}
        multiple
        accept={'image/*,video/mp4,application/pdf'}>
        <span>{I18n.t('Library.upload')}</span>
      </Dropzone>
    </div>)
  }

  _renderMediasUploader() {
    return (<div className={classNames(styles.uploader, styles.zip)}>
      <Dropzone
        onDrop={this.props.manageUploadMedias}
        activeClassName={styles.dropHover}
        rejectClassName={styles.dropError}
        accept={'application/zip'}>
        <span>{I18n.t('Library.uploadMediasZip')}</span>
      </Dropzone>
    </div>)
  }

  _renderAllMediasDownloader() {
    return (<div className={classNames(styles.uploader, styles.zip, styles.rotate)}>
      <a download 
        href={Constants.UrlsConstants.urlServer+Constants.UrlsConstants.mediaEntryPoint+'exportMedias/'+this.props.app.id+
        Constants.UrlsConstants.authTokenParam}>
          {I18n.t('Library.downloadAllMediasZip')}
      </a>
    </div>)
  }

  _renderUploaderFullSized() {
    return (<div id='uploaderFullsized'
      className={styles.uploaderFullsized}>
      <Dropzone
        onDrop={this.props.manageFileDrop}
        activeClassName={styles.dropHover}
        rejectClassName={styles.dropError}
        multiple
        accept={'image/*,video/mp4,application/pdf,image/gif'}>
        <span>{I18n.t('Library.upload')}</span>
      </Dropzone>
    </div>)
  }

  _renderMediasUploaderFullSized() {
    return (<div id='allMediasUploaderFullsized'
      className={styles.uploaderFullsized}>
      <Dropzone
        onDrop={this.props.manageUploadMedias}
        activeClassName={styles.dropHover}
        rejectClassName={styles.dropError}
        accept={'application/zip'}>
        <span>{I18n.t('Library.uploadMediasZip')}</span>
      </Dropzone>
    </div>)
  }

  _renderAllMediasDownloaderFullSized() {
    return (<div id='allMediasDownloaderFullsized'
      className={styles.uploaderFullsized}>
      <a download 
        href={Constants.UrlsConstants.urlServer+Constants.UrlsConstants.mediaEntryPoint+'exportMedias/'+this.props.app.id+
        Constants.UrlsConstants.authTokenParam}>
          {I18n.t('Library.downloadAllMediasZip')}
      </a>
    </div>)
  }

  _renderMediaPreview(media, index, props) {
    let mediaClassList = classNames(styles.media, media.mediaType, styles.uploading)
    return <div key={index} className={mediaClassList} disabled>
      {media.type.indexOf('image/') !== -1
        ? <img src={media.preview} />
        : null
      }
      {media.type === 'application/pdf'
        ? <img src={pdfImage} className={styles.iconFile}   />
        : null
      }
      {media.type === 'video/mp4'
        ? <img src className={styles.iconFile}   />
        : null
      }
      <div className={styles.mediaInfos}>
        <div className={styles.fileName}>{media.name}</div>
        <div className={styles.date}>{I18n.l(media.lastModified, { dateFormat: 'date.short' })}</div>
      </div>
    </div>
  }

  _renderMedia(media, index, draggable, props) {
    let mediaClassList = classNames(styles.media, media.mediaType)
    if (draggable) {
      return <div
        key={index}
        className={mediaClassList}
        draggable data-id={media.id}>
        {this._renderMediaImagePDF(media, index, draggable, props)}
      </div>
    } else {
      return <div key={index} className={mediaClassList}>
        {this._renderMediaImagePDF(media, index, draggable, props)}
      </div>
    }
  }

  _renderMediaImagePDF(media, index, draggable, props) {
    let dim = media.width + 'x' + media.height + 'px'
    let findIndexSize = this.props.mediasSize.findIndex(ms => ms.id === media.id)
    let size = findIndexSize !== -1 ? filesize(this.props.mediasSize[findIndexSize].size) : '... kB'
    let canDelete = !media.refMedias || media.refMedias.length === 0

    let mediaURL = Constants.UrlsConstants.urlServer + Constants.UrlsConstants.mediaMiniature +
      media.id + Constants.UrlsConstants.authTokenParam + '&' + media.creation

    let draggableClass = classNames(draggable ? styles.draggable : null)
    let mediaInfoClass = classNames(styles.mediaInfos, draggable ? styles.draggable : null)
    let removeClass = classNames(styles.remove, !canDelete ? styles.disabled : null)

    return this.state.selectedMedia && this.state.selectedMedia.id === media.id
      ? <div className={styles.mediaEditTagContainer}>
        <div className={styles.closeEditTag} onClick={() => this.setState({ selectedMedia: null, tagValue: '' })}></div>
        <div className={styles.tagsContainerLib}>
          <Creatable
            multi
            placeholder={I18n.t('Library.placeholderImgTags')}
            noResultsText={I18n.t('Library.noTagsFound')}
            options={this.props.mediasTags && this.props.mediasTags.length
              ? this.props.mediasTags.map(t => { return { value: t, label: t } })
              : []
            }
            value={media.tags && media.tags.length
              ? media.tags.map(t => { return { value: t, label: t } })
              : []
            }
            onChange={e => this.props.addTagToMedia(this.props.app.id, media.id, e.map(v => v.value))}
            formatCreateLabel={e => <span>{`Créer le tag ${e}`}</span>}
          />
          {/* {media.tags && media.tags.length
            ? media.tags.map((m, i) => (
              <div key={`tag-${media.id}-${i}`} className={styles.tag}>
                <div className={styles.tagText}>{m}</div>
                <div className={styles.tagRemove} onClick={() => {
                  let tags = media.tags
                  let findIndex = tags.indexOf(m)
                  if (findIndex > -1) {
                    tags.splice(findIndex, 1)
                  }
                  this.props.addTagToMedia(this.props.app.id, media.id, tags)
                }}></div>
              </div>
            ))
            : 'Aucun tag pour ce media'
          } */}
        </div>
      </div>
      : <div className={styles.imageContainer}>
        {media.type === 'IMAGE'
          ? this._renderMediaType(mediaURL, draggableClass, media, index, draggable, props)
          : this._renderMediaType(pdfImage, classNames(styles.iconFile, draggableClass), media, index, draggable)
        }
        <div className={mediaInfoClass}>
          <div className={styles.fileName}>{media.filename}</div>
          <div className={styles.date}>{I18n.l(media.creation, { dateFormat: 'date.short' })}</div>
          <div className={styles.dimensions}>{media.type === 'IMAGE' ? dim + ' (' + size + ')' : null}</div>
        </div>
        <div className={styles.tagsButton}
          onClick={() =>
            this.setState({ selectedMedia: media })
          }
          title={!canDelete ? I18n.t('Library.handleTags') : null}>
        </div>
        <div className={removeClass}
          onClick={canDelete ? this._handleDeleteMedia : null} data-id={media.id}
          title={!canDelete ? I18n.t('Library.noDelete') : null}>
        </div>
        <div className={styles.replace} style={{}}>
          <input type='file' accept={'image/*,video/mp4,application/pdf,image/gif'}
            onChange={this._handleReplaceMedia} data-id={media.id}
            title={I18n.t('Library.replace')} style={{ opacity: 0, width: '30px', height: '30px', cursor: 'pointer' }}
          />
        </div>
      </div>
  }

  _renderMediaType(imgSrc, imgClass, media, index, draggable, props) {
    let cls = classNames(imgClass, props && props.onImageClick ? styles.hoverable : null)
    if (draggable) {
      return (
        <img
          src={imgSrc}
          data-imageid={media.id}
          className={cls}
          data-filename={media.filename}
          data-mediatype={media.type}
          data-imagerank={index}
          onDragStart={this._handleDragStart}
          onDragEnd={this._handleDragEnd}
           
        />
      )
    } else {
      return (
        <img
          src={imgSrc}
          className={cls}
          onDragStart={this._preventDefault}
          data-imageid={media.id}
          onClick={props && props.onImageClick ? props.onImageClick : null} />
      )
    }
  }

  _preventDefault(e) {
    e.preventDefault()
  }

  _renderMediaCheckPreview(media, index, draggle, props) {
    if (media.preview) {
      return this._renderMediaPreview(media, index, props)
    } else {
      return this._renderMedia(media, index, draggle, props)
    }
  }

  _renderProgressSizeBar(totalSize) {
    let totalSizeMo = totalSize / 1e+6 || 0
    let maxSize = 50
    let pourcentage = (totalSizeMo / maxSize * 100)
    return (
      <div className={styles.progress}>
        <div className={styles.progressLabel}>
          {`${totalSizeMo.toFixed(2)} Mo /`}
          <div style={{ fontSize: '14px', marginLeft: '4px' }}>
            {`${maxSize} Mo ${I18n.t('Application.MoAvailable')}`}
          </div>
        </div>
        <div className={styles.progressBarBg}>
          <div className={styles.progressBar} style={{
            width: `${pourcentage === 0 ? 0.2 : Number.parseFloat(pourcentage).toFixed(2)}%`,
            background: pourcentage < 75 ? '#2eb92e' : pourcentage < 90 ? '#b9742e' : '#b92e2e',
          }}></div>
        </div>
      </div>
    )
  }
  _filterAndSortMedia(propMedia) {
    let media = JSON.parse(JSON.stringify(propMedia))
    if (media.length) {
      let sortProp = this.state.sort.split(':')[0]
      let sortLogic = this.state.sort.split(':')[1]
      if (sortProp === 'size') {
        for (let i = 0; i < media.length; i++) {
          let findIndex = this.props.mediasSize.findIndex(ms => ms.id === media[i].id)
          if (findIndex !== -1) media[i].size = this.props.mediasSize[findIndex].size
          else media[i].size = 0
        }
      }
      let newMedia = media.filter(m => {
        if (this.state.showUsed && this.state.showUnused) return true
        if ((!this.state.showUnused && !m.refMedias.length) ||
          (!this.state.showUsed && m.refMedias.length)) return false
        return true
      }).sort((m1, m2) => {
        if (sortProp !== 'refMedias') {
          if (m1[sortProp] < m2[sortProp]) return -1
          if (m1[sortProp] > m2[sortProp]) return 1
          return 0
        } else {
          if (m1[sortProp].length < m2[sortProp].length) return -1
          if (m1[sortProp].length > m2[sortProp].length) return 1
          return 0
        }
      })
      return sortLogic === 'ASC' ? newMedia : newMedia.reverse()
    } else return []
  }
  _renderFilterToolbar(type) {
    return (
      <div className={styles.filterContainer}>
        <label className={styles.labelContainer}>
          <span>Non utilisés</span>
          <Toggle type={'check'} position={0} toggleInitState={this.state.showUnused}
            toggleChanged={this._onToggleUnusedChange} />
        </label>
        <label className={styles.labelContainer}>
          <span>Utilisés</span>
          <Toggle type={'check'} position={1} toggleInitState={this.state.showUsed}
            toggleChanged={this._onToggleUsedChange} />
        </label>
        <Select className={globalStyles.select} style={type === 'full'
          ? { minWidth: '300px', marginRight: '16px' }
          : { minWidth: '200px' }
        }
          options={[
            { value: 'filename:ASC', label: 'Nom du fichier - A -> Z' },
            { value: 'filename:DESC', label: 'Nom du fichier - Z -> A' },
            { value: 'creation:ASC', label: 'Date d\'ajout - Ancien -> Récent' },
            { value: 'creation:DESC', label: 'Date d\'ajout - Récent -> Ancien' },
            { value: 'size:ASC', label: 'Poid du fichier - Léger -> Lourd' },
            { value: 'size:DESC', label: 'Poid du fichier - Lourd -> Léger' },
            { value: 'refMedias:ASC', label: 'Nombre d\'utilisation - Moins -> Plus' },
            { value: 'refMedias:DESC', label: 'Nombre d\'utilisation - Plus -> Moins' },
          ]}
          onChange={this._handleSelectChange}
          value={this.state.sort}
        />
        {type === 'full'
          ? <Select
            className={globalStyles.select}
            style={{ width: '300px' }}
            multi
            disabled={!this.props.mediasTags || !this.props.mediasTags.length}
            placeholder={I18n.t('Library.tagPlaceHolder')}
            noResultsText={I18n.t('Library.noTagsFound')}
            options={this.props.mediasTags && this.props.mediasTags.length
              ? this.props.mediasTags.map(t => { return { value: t, label: t } })
              : []
            }
            value={this.props.selectedMediaTags}
            onChange={e => this.props.updateSelectedMediaTags(e)}
          />
          : null
        }
      </div>
    )
  }
  _renderFilterTags = () => {
    return <Select
      className={globalStyles.select}
      style={{ width: '100%', margin: 'auto', marginBottom: '32px' }}
      multi
      disabled={!this.props.mediasTags || !this.props.mediasTags.length}
      value={this.props.selectedMediaTags}
      onChange={e => this.props.updateSelectedMediaTags(e)}
      placeholder={I18n.t('Library.tagPlaceHolder')}
      noResultsText={I18n.t('Library.noTagsFound')}
      options={this.props.mediasTags && this.props.mediasTags.length
        ? this.props.mediasTags.map(t => { return { value: t, label: t } })
        : []
      }
    />
  }
  _onToggleUnusedChange() {
    let showUnused = this.state.showUnused
    showUnused = !showUnused
    this.setState({ showUnused })
  }
  _onToggleUsedChange() {
    let showUsed = this.state.showUsed
    showUsed = !showUsed
    this.setState({ showUsed })
  }
  _handleSelectChange(e) {
    if (e) this.setState({ sort: e.value })
  }
}

export default BaseLibrary

